import Vue from "vue";

// 用途：request.js、页面组件这些普通JS/组件，用这个事件总线统一"喊一声"弹登录窗，
// App.vue监听 show-login 事件负责真正弹出弹窗、登录成功后回调调用方传入的函数。
const bus = new Vue();

export default bus;
